import { search } from "../../../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/prouser/clientescolaborador/v1`;

const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findClienteColaborador({
  empresa_cnpj,
  id,
  include,
  where = {},
  orwhere = {},
  page,
  perPage,
  fields,
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere[${key}]=${orwhere[key]}`;
  });

  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }${page ? `&page=${page}` : ""}${perPage ? `&per_page=${perPage}` : ""}${
      fields ? `&fields${fields}` : ""
    }`,
    "GET",
    headers
  );
}

export async function findClienteColaboradorByCpfCnpj(empresa_cnpj, cpfcnpj) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}&where[cpfcnpj]=${cpfcnpj}`,
    "GET",
    headers
  );
}

export async function createClienteColaborador(
  empresa_cnpj,
  body,
  include = ""
) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}${
      include ? `&include=${include}` : ""
    }`,
    "POST",
    headers,
    body
  );
}

export async function updateClienteColaborador(id, empresa_cnpj, body) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}

export function deleteClienteColaborador(id, empresa_cnpj) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "DELETE",
    headers
  );
}
